import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";
import Table from "../components/Table";
import filePDF from "../assets/images/file-pdf.svg";
import api from "../utils/api";
import TableSorting from "../components/TableSorting";
import PdfDownloader from "../components/PdfDownloader";
import ErrorComp from "../components/ErrorComp";

const SavingPage = (props) => {
  const [tableHeader, setTableHeader] = useState(
    window.innerWidth < 767
      ? [
          { label: "חברת ביטוח", sortable: false, engTrns: "logo" },
          { label: "מספר פוליסה", sortable: true, engTrns: "field1" },
          { label: "", sortable: false, engTrns: "field9" },
          { label: "סוג פוליסה", sortable: true, engTrns: "field2" },
          { label: "סטטוס", sortable: true, engTrns: "field3" },
          { label: "הפקדות לשנה", sortable: false, engTrns: "field4" },
          { label: "הפקדה אחרונה ", sortable: false, engTrns: "field5" },
          { label: "סך חיסכון ", sortable: false, engTrns: "field6" },
          { label: "שיעור תשואה ", sortable: false, engTrns: "field7" },
          { label: "שיעור דמי ניהול", sortable: false, engTrns: "field8" },
          { label: "תאריך נכונות", sortable: false, engTrns: "field10" },
        ]
      : [
          { label: "חברת ביטוח", sortable: false, engTrns: "logo" },
          { label: "מספר פוליסה", sortable: true, engTrns: "field1" },
          { label: "סוג פוליסה", sortable: true, engTrns: "field2" },
          { label: "סטטוס", sortable: true, engTrns: "field3" },
          { label: "הפקדות לשנה", sortable: false, engTrns: "field4" },
          { label: "הפקדה אחרונה ", sortable: false, engTrns: "field5" },
          { label: "סך חיסכון ", sortable: false, engTrns: "field6" },
          { label: "שיעור תשואה ", sortable: false, engTrns: "field7" },
          { label: "שיעור דמי ניהול", sortable: false, engTrns: "field8" },
          { label: "תאריך נכונות", sortable: false, engTrns: "field10" },
          { label: "", sortable: false, engTrns: "field9" },
        ]
  );
  const [tableHeaderSort, setTableHeaderSort] = useState([
    { key: "name", label: "שם הקופה" },
    { key: "monthly", label: "חודשי" },
    { key: "monthly_sum", label: "12 חודשים אחרונים" },
    { key: "threeYears", label: "3 שנים" },
    { key: "fiveYears", label: "5 שנים" },
    {
      key: "depositmanagementfee",
      label: "דמי ניהול ממוצעים",
      tooltip: "Lorem Ipsum הוא פשוט טקסט דמה של תעשיית הדפוס והקביעה.",
    },
    {
      key: "propertymanagementfees",
      label: "שארפ 5 שנים ",
      tooltip: "Lorem Ipsum הוא פשוט טקסט דמה של תעשיית הדפוס והקביעה.",
    },
    {
      key: "totalAssets",
      label: "היקף נכסים",
      tooltip: "Lorem Ipsum הוא פשוט טקסט דמה של תעשיית הדפוס והקביעה.",
    },
  ]);
  const [yieldDataFirst, setYieldDataFirst] = useState([]);
  // setYieldDataFirst(props?.yieldsAll?.[0]?.yields_gemel || []);

  useEffect(() => {
  if (props?.yieldsAll?.[0]?.yields_gemel) {
    setYieldDataFirst(props.yieldsAll[0].yields_gemel);
  }
}, [props?.yieldsAll]);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setData(props?.savings || []);
      } catch (err) {
        console.log(err);
      } finally {
        if (props?.onboardingStep >= 4) {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [props?.savings, props?.onboardingStep]);
  const [UserData, setUserData] = useState({});
  const getUser = async () => {
    setUserData(props?.data || {});
  };

  useEffect(() => {
    if (
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/register"
    ) {
      getUser();
    }
  }, [props?.data]);

  return (
    <>
      <div className="heading-wrap d-flex justify-content-between">
        <div className="heading">
          <div className="head-wrap">
            <Breadcrumbs className="breadcrumbs" aria-label="breadcrumb">
              <Link to="/profile" underline="hover">
                {UserData?.full_name || ""}
              </Link>
              <Typography>
                <b>חיסכון</b>
              </Typography>
            </Breadcrumbs>
            <h1>ברוכים השבים , {UserData?.full_name || ""}</h1>
          </div>
          <p>
            ברוכים הבאים ללוח הבקרה של החיסכון שלכם!
            <br /> עמוד זה מציע סקירה מקיפה של מטרות החיסכון וההתקדמות שלכם, כדי
            לעזור לכם להישאר על המסלול להשגת ביטחון פיננסי. עקבו אחרי החסכונות
            הנוכחיים שלכם, נטרו את ההפקדות ובחנו אסטרטגיות חיסכון שונות שמתאימות
            למטרותיכם. עם המלצות מותאמות אישית והדמיות ברורות, תקבלו את התובנות
            הנדרשות כדי למקסם את החיסכון ולהגיע ליעדים שלכם במהירות רבה יותר.
          </p>
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="savingpage.pdf">
              <img src={filePDF} alt="" />
            </PdfDownloader>
          </div>
        </div>
        <div className="btns-row">
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="savingpage.pdf">
              <img src={filePDF} alt="" /> הפקת דוח
            </PdfDownloader>
          </div>
        </div>
      </div>
      {props?.onboarding_error === 1 && <ErrorComp />}

      <>
        <Table
          tableHeader={tableHeader}
          data={data}
          from="savingPageOrig"
          title="חיסכון"
          loading={loading}
          notFoundMessage="חיסכון"
          carrierLogos={props?.carrierLogos}
        />
      </>

      <div className="table-main">
        <div className="title d-flex justify-content-between">
          <h2>פוליסות חיסכון מובילות</h2>
        </div>
        <div className="objective-box d-flex">
          <div className="table-main-left w_100">
            <>
              <TableSorting
                yieldDataFirst={yieldDataFirst || []}
                tableHeaderSort={tableHeaderSort}
                from="PensionPage"
                carrierLogos={props?.carrierLogos}
              />
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default SavingPage;
